import React from "react";
import Div100vh from "react-div-100vh";
import { useNavigate } from "react-router-dom";
import cardImg from "@/assets/images/card-bg-re.jpg";
import bgRe from "@/assets/images/bg-re.svg";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import GoBackButton from "@/components/common/buttons/GoBackButton";
import Header from "../common/Header/header";

export default function RejectedScreen({
  isLandlord = false,
  showBackButton = false,
}) {
  const navigate = useNavigate();

  return (
    <Div100vh
      className="flex flex-col justify-between py-5 bg-no-repeat bg-cover"
      style={{
        backgroundImage: `url(${bgRe})`,
      }}
    >
      <style>
        {`
          .hover\\:icon-white:hover img {
            filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(93deg) brightness(102%) contrast(102%);
          }
        `}
      </style>
      <div
        className={`flex flex-col ${
          isLandlord ? "justify-start" : "justify-center"
        } w-full h-full items-center gap-48 text-[#aaa] p-6`}
      >
        {isLandlord && (
          <div className="flex w-full">
            <Header customBackSubmit={() => navigate("/update-landlord")} showProfile />
          </div>
        )}
        <div className="flex flex-col items-center justify-center gap-4">
          <div className="flex flex-col items-center justify-center gap-1">
            <h1 className="text-[#eee] text-md font-semibold">
              {isLandlord ? "Thank you for signing up" : "Uh Oh😕"}
            </h1>
            <p>{isLandlord ? "" : "Good things are worth the wait."}</p>
          </div>
          <div
            className="mx-4 flex flex-col text-[#eee] rounded-lg items-center justify-center gap-4 p-10 bg-gradient-to-br from-[#0031FB] via-[#0000cc] to-[#010101] bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url(${cardImg})`,
            }}
          >
            <p className="text-center">
              {isLandlord
                ? "Our Team will be reaching out to you within 24 hours."
                : "Though you could invite your friends or flatmates to check their eligibility."}
            </p>
            {!isLandlord && (
              <button
                name="send invite button"
                className="text-xs items-center flex border bg-black py-3 pr-3 pl-5"
              >
                Send Invite <ArrowUpRight className="mx-2 size-5" />
              </button>
            )}
          </div>
          {!isLandlord && (
            <button
              onClick={() => {
                navigate("/home");
              }}
              className="flex gap-2 items-center"
            >
              Continue to Explore <ArrowRight className="size-5" />
            </button>
          )}
        </div>
      </div>
    </Div100vh>
  );
}
